// // const cache = new Map();
// if (!window.__reportCacheStore) {
//     window.__reportCacheStore = new Map();
// }
// const cache = window.__reportCacheStore;
// //console.log("Module evaluated, cache id:", Math.random()); // should print ONCE ever

// // window.__cacheDebug = () => ({
// //     keys: [...cache.keys()],
// //     size: cache.size,
// //     get: (k) => cache.get(k),
// // });

// export function getCached(campaignId, shortName) {
//     //console.log("GET", `${campaignId}_${shortName}`, "all keys:", [...cache.keys()]);
//     return cache.get(`${campaignId}_${shortName}`);
// }

// export function setCached(campaignId, shortName, data) {
//     //console.log("SET", `${campaignId}_${shortName}`);
//     cache.set(`${campaignId}_${shortName}`, data);
// }

if (!window.__reportCacheStore) {
    window.__reportCacheStore = new Map();
}

const cache = window.__reportCacheStore;

export function getCached(campaignId, shortName) {
    const key = `${campaignId}_${shortName}`;
    const value = cache.get(key);
    console.log("GET", key, "| hit:", !!value);
    return value;
}

export function setCached(campaignId, shortName, data) {
    const key = `${campaignId}_${shortName}`;
    console.log("SET", key);
    cache.set(key, data);
}
